<template>
  <div class="newsInformation">
    <detailsTop :topIndex="topIndex" @bannerIndexClick="bannerIndexClick" />
    <div class="news-content">
      <div class="new-center">
        <bannerTips
          :bannerTipsList="bannerTipsList"
          @changeTips="changeTips"
          :bannerIndex="bannerIndex"
        />
        <div class="new-list">
          <!-- 企业简介 -->
          <div class="brief" v-show="bannerIndex == 0">
            <div class="brief-right" v-html="newInfo.content"></div>
            <div class="brief-left">
              <div class="timeline">
                <div
                  class="entry"
                  v-for="(item1, index1) in timeList"
                  :key="index1"
                >
                  <div class="title">
                    <h3>{{ item1 }}</h3>
                  </div>
                  <div class="body">
                    <p v-for="(item2, index2) in historyList" :key="index2">
                      <span v-if="item1 == item2.title">
                        {{ item2.introduction }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 企业文化 -->
          <div class="culture" v-show="bannerIndex == 1">
            <div class="cultrue-logo">
              <div class="logo">
                <img src="@/assets/images/logo-img.png" alt="logo" />
              </div>
              <div class="logo-right">
                <p class="logo-title">logo意义:</p>
                <p class="logo-content">
                  “娲石”源于中国古代女娲炼五色石补天的神话传说，寓意“娲石”具有女娲精神和五色石的品质。商标图案主体为“娲石”的汉语拼音W、S的巧妙组合。<br />

                  “S”变形为圆，含“太极八荒”之意，即地球；“W”中峰穿越“S”中线，形象地表达出“女娲补天”的意念，“W”两边画与圆相切，示意女娲双手托起地球，与图案底横线有机结合，展示娲石人不断超越自我、蓬勃向上和脚踏实地的务实精神。
                </p>
              </div>
            </div>
            <div class="cultrue-boss">
              <div class="boss-right">
                <p class="boss-title">董事长寄语：</p>
                <p class="msg">
                  &nbsp;&nbsp; &nbsp;&nbsp;
                  顺势而为，乘势而上，发扬女娲补天精神，传承娲石品质，把娲石集团打造成为中国百强、百年企业，为国家富强、民族复兴、人民幸福、共同富裕创造坚实未来！
                </p>
              </div>
              <div class="boss-img">
                <img src="@/assets/images/dsz.jpg" alt="" />
                <p class="img-p">娲石集团党委书记、董事长 魏华山</p>
              </div>
            </div>
            <div class="cultrue-mind">
              <div class="mind">
                <p class="mind-title">企业精神</p>
                <p class="mind-content">
                  超越自我，敢为人先<br />
                  实事求是，创新求精
                </p>
              </div>
              <div class="mind">
                <p class="mind-title">办企理念</p>
                <p class="mind-content">为职工谋福祉 为社会做贡献。</p>
              </div>
              <div class="mind">
                <p class="mind-title">经营理念</p>
                <p class="mind-content">思路决定出路，人品铸就产品。</p>
              </div>
            </div>
          </div>

          <!-- 组织架构 -->
          <div class="group" v-show="bannerIndex == 2">
            <div class="group-bottom">
              <p class="bottom-p">集团旗下公司</p>
              <div
                class="group-item"
                v-for="(item1, index1) in groupList"
                :key="index1"
              >
                <div class="group-title">{{ item1 }}</div>
                <div class="group-sort">
                  <div
                    class="group-div"
                    v-for="(item2, index2) in newList"
                    :key="index2"
                  >
                    <span class="group-p" v-if="item1 == item2.title">{{
                      item2.source
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 主要业务 -->
          <div class="business" v-show="bannerIndex == 3">
            <div class="left-title">
              <p
                class="left-title-p"
                v-for="(item, index) in titleList"
                :key="index"
                @click="changeTitle(item)"
              >
                0{{ index + 1 }} {{ item }}
              </p>
            </div>
            <div class="right-content">
              <div
                class="content-item"
                v-for="(item, index) in titleItemList"
                :key="index"
              >
                <el-image
                  class="content-item-img"
                  lazy
                  :src="baseURL + item.cover"
                >
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                </el-image>
                <div class="content-item-p">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>

          <!-- 集团荣誉 -->
          <div class="honor" v-show="bannerIndex == 4">
            <el-tabs tabPosition="left" @tab-click="handleTabClick">
              <el-tab-pane
                v-for="(item, index) in honorTime"
                :key="index"
                :label="item"
              >
                <div class="honor-left">
                  <div
                    class="honor-item"
                    v-for="(item, index) in cilckList"
                    :key="index"
                  >
                    <el-image
                      lazy
                      :src="baseURL + item.cover"
                      class="honor-image"
                    >
                      <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                    <p class="honor-title">{{ item.title }}</p>
                  </div>
                </div>
              </el-tab-pane>
              <!-- 分页 -->
              <div class="pagination">
                <el-pagination
                  background
                  @current-change="handleCurrentChange"
                  prev-text="上一页"
                  next-text="下一页"
                  :current-page.sync="pagenum"
                  :page-size="sizenum"
                  layout="prev, pager, next, jumper"
                  :total="totalnum"
                >
                </el-pagination>
              </div>
            </el-tabs>
          </div>
        </div>
      </div>
      <div class="new-right"></div>
    </div>

    <pageBottom />
  </div>
</template>

<script>
import detailsTop from "@/components/detailsTop.vue";
import pageBottom from "@/components/pageBottom";
import bannerTips from "@/components/bannerTips";
import { selectTNewsPage, getTNewsInfo } from "@/api/api.js";

export default {
  name: "news1",
  components: {
    detailsTop,
    pageBottom,
    bannerTips,
  },
  data() {
    return {
      bannerTipsList: [],
      topIndex: null,
      bannerIndex: 0,
      page: 1,
      size: 100,
      total: null,
      newList: [],
      newInfo: {},
      historyList: [], //时间轴列表
      timeList: [], //时间轴上面的时间
      honorTime: [],
      cilckList: [], //荣誉分页列表
      honorList: [], //荣誉列表
      groupList: [], //组织列表
      pagenum: 1,
      sizenum: 6,
      totalnum: 100,
      titleList: [], //主要业务标题列表
      titleItemList: [],
    };
  },
  created() {
    this.topIndex = this.$route.query.topIndex;
    this.bannerTipsList = JSON.parse(localStorage.getItem("bannerList"));
    this.bannerIndex = Number(localStorage.getItem("lobannerIndex"));
    this.getData();
  },
  mounted() {
    const that = this;
    window.addEventListener("setItemEvent", function (e) {
      if (e.key === "lobannerIndex") {
        // myKey是需要监听的键名
        that.lobannerIndex = e.newValue;
        that.bannerIndex = e.newValue;
        that.getData();
      }
    });
  },
  methods: {
    goAnchor(selector) {
      document.querySelector(selector).scrollIntoView({
        behavior: "smooth",
      });
    },

    bannerIndexClick(index) {
      // this.bannerIndex = index;
    },
    changeTips(index) {
      //点击以后下标改变了，重新接受值
      this.bannerIndex = index;
      this.getData();
    },
    async getData() {
      var params = {
        page: this.page,
        size: this.size,
        projectTypeParentId: this.bannerTipsList[this.bannerIndex]?.parentId,
        projectTypeSubId: this.bannerTipsList[this.bannerIndex]?.projectTypeId,
      };
      const { data } = await selectTNewsPage(params);
      if (data.code === 200) {
        this.newList = data.data.list;
        this.total = data.data.total;
        this.historyList = [];
        this.timeList = [];
        this.titleList=[]
      }
      //获取第一个企业简介的第一版内容
      let newsId = this.newList[0].newsId;
      let projectTypeParentId = this.newList[0].projectTypeParentId;
      this.getNewInfo(newsId, projectTypeParentId);

      //企业简介
      if (this.bannerIndex == 0) {
        this.historyList = this.newList.slice(1);
        this.historyList.forEach((item) => {
          item.title = Number(item.title); //转数字，方便排序
          this.timeList.push(item.title);
        });

        this.timeList.sort(function (a, b) {
          return b - a;
        });
        this.timeList = [...new Set(this.timeList)];
      }

      //组织架构
      if (this.bannerIndex == 2) {
        this.newList?.forEach((item) => {
          this.groupList.push(item.title);
        });
        this.groupList = [...new Set(this.groupList)];
      }

      //主要业务
      if (this.bannerIndex == 3) {
        this.newList?.forEach((item) => {
          this.titleList.push(item.source);
        });
        this.titleList = [...new Set(this.titleList)];
        let firstTitle = this.titleList[0];
        this.titleItemList = this.newList.filter(
          (item) => item.source == firstTitle
        );

      }

      //当点击集团荣誉时   if比较的时候会比较类型
      if (this.bannerIndex == 4) {
        this.newList.forEach((item) => {
          this.honorTime.push(item.source);
        });

        this.honorTime = [...new Set(this.honorTime)];
        this.honorTime.sort(function (a, b) {
          return b - a;
        });

        let firstYear = this.honorTime[0];
        this.honorList = this.newList.filter(
          (item) => item.source == firstYear
        );

        //分页默认效果
        this.totalnum = this.honorList.length;
        this.cilckList = this.honorList.slice(0, this.sizenum);
      }
    },
    //获取到文章详情
    async getNewInfo(newsId, projectTypeParentId) {
      const { data } = await getTNewsInfo({
        newsId: newsId,
        projectTypeParentId: projectTypeParentId,
      });
      this.newInfo = data.data;
    },

    handleTabClick(tab) {
      let year = tab.label;
      this.honorList = this.newList.filter((item) => item.source == year);
      this.cilckList = this.honorList.slice(0, this.sizenum);
      this.totalnum = this.honorList.length;
    },

    jumpYear(index) {
      document.documentElement.scrollTop = 300 * (index + 1);
    },

    IsGroup(item, index) {
      this.groupList[index] == item.title;
    },

    handleCurrentChange(val) {
      this.pagenum = val;
      this.cilckList = this.honorList.slice(
        (this.pagenum - 1) * this.sizenum,
        this.pagenum * this.sizenum
      );
    },
    changeTitle(item){
      let title = item;
      this.titleItemList = this.newList.filter(
          (item) => item.source == title
        );
    },
  },
};
</script>

<style scoped lang="less">
* {
  scroll-margin-top: 100px; //加在有滚动条的元素身上，可以是html
}

.news-content {
  width: 100%;
  height: 100%;

  .new-center {
    width: 86%;
    max-width: 1440px;
    margin: 20px auto;
    background: #f4f4f4;

    .new-list {
      margin: 22px 0;
      background: #ffffff;
      width: 100%;
      box-sizing: border-box;
    }

    .pagination {
      margin: 4% auto;
    }
  }

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #46739f;
    color: #fff;
  }
}

@media only screen and (max-width: 1550px) {
  .new-center {
    flex: 12 !important;
    background: #f4f4f4;
  }
}

//企业简介
.brief {
  width: 100%;
  padding: 30px 40px;
  display: flex;
  justify-content: space-between;

  .brief-right {
    width: 40%;
    text-align: left;
  }
  .brief-left {
    width: 50%;
    height: 850px;
    overflow: auto;
    cursor: default;
  }
}

//时间轴

body {
  background: linear-gradient(55deg, #4e75b9 30%, #5cbf98 90%);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 12vh 100px;
  font-family: "Source Sans Pro", arial, sans-serif;
  font-weight: 300;
  color: #333;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
}

.timeline {
  width: 100%;
  max-width: 800px;
  background: #fff;
  padding: 50px;
  position: relative;
  box-shadow: 0.5rem 0.5rem 2rem 0 rgba(black, 0.2);
}
.timeline::before {
  content: "";
  position: absolute;
  top: 0px;
  left: calc(33% + 15px);
  bottom: 0px;
  width: 4px;
  background: #ddd;
}
.timeline::after {
  content: "";
  display: table;
  clear: both;
}

.entry {
  clear: both;
  text-align: left;
  position: relative;
  .title {
    margin-bottom: 0.5em;
    float: left;
    width: 33%;
    padding-right: 30px;
    text-align: right;
    position: relative;

    h3 {
      margin: 0;
      font-size: 150%;
    }
    p {
      margin: 0;
      font-size: 100%;
    }
  }
  .body {
    margin: 0 0 3em;
    float: right;
    width: 66%;
    padding-left: 30px;
    p {
      line-height: 1.4em;

      span {
        font-size: 16px;
        line-height: 30px;
      }
    }
    p:first-child {
      margin-top: 0;
      font-weight: 400;
    }
  }
}

.title::before {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  border: 4px solid salmon;
  background-color: #fff;
  border-radius: 100%;
  top: 15%;
  right: -8px;
  z-index: 99;
}

// 滚动条样式
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
}
::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}

//企业文化
.culture {
  width: 100%;

  .cultrue-logo {
    width: 100%;
    padding: 30px 40px;
    background-color: #f4f5f5;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .logo {
      width: 20%;

      img {
        width: 250px;
        height: 200px;
      }
      img:hover {
        transform: scale(1.2);
      }
    }
    .logo-right {
      width: 70%;

      .logo-title {
        font-size: 25px;
        font-weight: 600;
        color: #333;
        text-align: left;
        padding-left: 30px;
        box-sizing: border-box;
        margin-bottom: 20px;
      }

      .logo-content {
        height: 200px;
        padding-left: 80px;
        box-sizing: border-box;
        text-align: left;
        font-size: 20px;
        line-height: 36px;
        color: #333;
      }
    }
  }

  .cultrue-boss {
    width: 100%;
    padding: 30px 40px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .boss-img {
      width: 30%;
      height: 340px;

      img {
        height: 300px;
      }
      .img-p {
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
        margin: 30px 0;
      }
    }

    .boss-img:hover {
      img {
        transform: scale(1.2);
      }

      .img-p {
        font-size: 20px;
      }
    }

    .boss-right {
      width: 60%;

      .boss-title {
        font-size: 36px;
        font-weight: 700;
        color: #333;
        text-align: left;
        padding-left: 30px;
        box-sizing: border-box;
        margin-bottom: 20px;
      }

      .msg {
        padding-left: 80px;
        box-sizing: border-box;
        font-size: 24px;
        color: #333;
        line-height: 40px;
        text-align: left;
      }
    }
  }

  .cultrue-mind {
    width: 100%;
    height: 300px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .mind {
      width: 32%;
      height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      background-color: #f4f5f5;

      .mind-title {
        font-size: 28px;
        line-height: 50px;
        color: #46739f;
        font-weight: 700;
      }

      .mind-content {
        font-size: 20px;
        color: #333;
        line-height: 40px;
      }
    }

    .mind:hover {
      .mind-title {
        font-size: 40px;
      }

      .mind-content {
        font-size: 26px;
      }
    }
  }
}

//组织架构
.group {
  width: 100%;
  padding: 30px 40px;

  .group-content {
    width: 100%;
    text-align: left;
  }
  .group-bottom {
    width: 100%;
    text-align: left;

    .bottom-p {
      font-size: 30px;
      color: #333;
      font-weight: 600;
    }

    .group-item {
      width: 100%;
      padding: 20px 0;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e0dbdb;

      .group-title {
        cursor: pointer;
        width: 20%;
        height: 70px;
        line-height: 70px;
        margin: 20px 30px 20px 0;
        font-size: 26px;
        color: #fff;
        background-color: #4778a9;
        text-align: center;
      }

      .group-sort {
        width: 80%;
        display: flex;
        flex-wrap: wrap;

        .group-div {
          .group-p {
            display: block;
            cursor: pointer;
            min-width: 320px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            font-weight: 600;
            color: #333;
            margin: 5px 30px 5px 0;
            box-sizing: border-box;
            background-color: rgb(219, 215, 215);
          }
          .group-p:hover {
            font-size: 18px;
          }
        }
      }
    }

    ul {
      width: 100%;
      margin: 20px 0;
      font-size: 24px;
      color: #333333;
      font-weight: 500;
      display: flex;
      justify-content: space-between;
    }
  }
}

//主要业务
.business {
  width: 100%;
  padding: 30px 40px;
  display: flex;
  justify-content: space-between;

  .left-title {
    width: 35%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .left-title-p {
      width: 100%;
      height: 80px;
      text-align: left;
      font-size: 18px;
      color: #191919;
      line-height: 80px;
      cursor: pointer;
    }
    .left-title-p:hover {
      font-size: 24px;
      color: #fff;
      background-color: #4778a9;
    }
  }
  .right-content {
    width: 60%;
    display: flex;
    flex-wrap: wrap;

    .content-item {
      width: 46%;
      height: 260px;
      margin-right: 6%;
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;

      .content-item-img {
        width: 100%;
        height: 230px;
      }
      .content-item-p {
        width: 100%;
        height: 40px;
        font-size: 18px;
        font-weight: 600;
        line-height: 40px;
        text-align: center;
      }
    }
    .content-item:hover {
      box-shadow: 5px 5px 5px 2px rgba(0, 0, 0, 0.3);
    }

    .content-item:nth-child(2n) {
      margin-right: 0;
    }
    .content-item:last-child {
      margin-right: auto;
    }
  }
}

//集团荣誉
.honor {
  width: 100%;
  padding: 30px 40px;
  .honor-left {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .honor-item {
      width: 32%;
      margin-right: 2%;
      margin-bottom: 30px;

      .el-image {
        height: 230px;
        overflow: hidden;
      }

      .honor-title {
        width: 100%;
        height: 90px;
        font-size: 16px;
        text-align: center;
        color: #333;
        line-height: 40px;
        font-weight: 600;
      }
    }

    .honor-item:nth-child(3n) {
      margin-right: 0;
    }
    .honor-item:last-child {
      margin-right: auto;
    }

    .honor-item:hover {
      .el-image {
        transform: scale(1.1);
      }
      .honor-title {
        font-size: 26px;
      }
    }
  }
}

::v-deep .el-tabs--left .el-tabs__header.is-left {
  margin-right: 40px !important;
}

::v-deep .el-tabs__nav {
  height: 300px;
  overflow: auto;
}

::v-deep .el-tabs__active-bar {
  background: none;
}
::v-deep .el-tabs__item {
  height: 50px;
  font-size: 20px;
}
// 滚动条样式
::v-deep ::-webkit-scrollbar {
  width: 3px;
  height: 6px;
}
::v-deep ::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
}
::v-deep ::-webkit-scrollbar-thumb {
  background: #409eff;
  border-radius: 10px;
}

/* -------------------------------- 

Main components 

-------------------------------- */

#cd-timeline {
  position: relative;
  padding: 2em 0;
  margin-top: 2em;
  margin-bottom: 2em;
}
#cd-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 25px;
  height: 100%;
  width: 4px;
  background: #333;
}
@media only screen and (min-width: 1170px) {
  #cd-timeline {
    margin-top: 3em;
    margin-bottom: 3em;
  }
  #cd-timeline::before {
    left: 50%;
    margin-left: -2px;
  }
}

.cd-timeline-block {
  position: relative;
  margin: 2em 0;
  min-height: 200px;
}
.cd-timeline-block:after {
  content: "";
  display: table;
  clear: both;
}
.cd-timeline-block:first-child {
  margin-top: 0;
}
.cd-timeline-block:last-child {
  margin-bottom: 0;
}
@media only screen and (min-width: 1170px) {
  .cd-timeline-block {
    margin: 4em 0;
  }
  .cd-timeline-block:first-child {
    margin-top: 0;
  }
  .cd-timeline-block:last-child {
    margin-bottom: 0;
  }
}

.cd-timeline-img {
  position: absolute;
  top: 8px;
  left: 12px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  box-shadow: 0 0 0 4px #333, inset 0 2px 0 rgba(0, 0, 0, 0.08),
    0 3px 0 4px rgba(0, 0, 0, 0.05);
}
.cd-timeline-img {
  background: #fff;
}
@media only screen and (min-width: 1170px) {
  .cd-timeline-img {
    width: 20px;
    height: 20px;
    left: 50%;
    margin-left: -10px;
    margin-top: 15px;
    /* Force Hardware Acceleration in WebKit */
    -webkit-transform: translateZ(0);
    -webkit-backface-visibility: hidden;
  }
}

.cd-timeline-content {
  position: relative;
  margin-left: 60px;
  margin-right: 30px;
  border-radius: 2px;
  padding: 1em;
  .timeline-content-info {
    padding: 5px 10px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 12px;
    box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.08);
    border-radius: 2px;
    i {
      margin-right: 5px;
    }
    .timeline-content-info-title,
    .timeline-content-info-date {
      width: calc(50% - 2px);
      display: inline-block;
    }
    @media (max-width: 500px) {
      .timeline-content-info-title,
      .timeline-content-info-date {
        display: block;
        width: 100%;
      }
    }
  }
  .content-skills {
    font-size: 12px;
    padding: 0;
    margin-bottom: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    li {
      background: #40484d;
      border-radius: 2px;
      display: inline-block;
      padding: 2px 10px;
      color: rgba(255, 255, 255, 0.7);
      margin: 3px 2px;
      text-align: center;
      flex-grow: 1;
    }
  }
}
.cd-timeline-content:after {
  content: "";
  display: table;
  clear: both;
}
.cd-timeline-content h2 {
  color: rgba(255, 255, 255, 0.9);
  margin-top: 0;
  margin-bottom: 5px;
}
.cd-timeline-content p,
.cd-timeline-content .cd-date {
  color: #333333;
  font-size: 18px;
}
.cd-timeline-content .cd-date {
  display: inline-block;
}
.cd-timeline-content p {
  margin: 1em 0;
  line-height: 1.6;
}


@media only screen and (min-width: 768px) {
  .cd-timeline-content h2 {
    font-size: 20px;
    font-size: 1.25rem;
  }
  .cd-timeline-content p {
    font-size: 16px;
    font-size: 1rem;
  }
  .cd-timeline-content .cd-read-more,
  .cd-timeline-content .cd-date {
    font-size: 18px;
  }
}
@media only screen and (min-width: 1170px) {
  .cd-timeline-content {
    color: white;
    margin-left: 0;
    padding: 1.6em;
    width: 36%;
    margin: 0 5%;
  }
  .cd-timeline-content::before {
    top: 24px;
    left: 100%;
    border-color: transparent;
    border-left-color: #333c42;
  }
  .cd-timeline-content .cd-date {
    position: absolute;
    width: 100%;
    left: 80%;
    top: 20px;
    font-size: 18px;
  }
  .cd-timeline-block:nth-child(even) .cd-timeline-content {
    float: right;
  }
  .cd-timeline-block:nth-child(even) .cd-timeline-content::before {
    top: 24px;
    left: auto;
    right: 100%;
    border-color: transparent;
    border-right-color: #333c42;
  }
  .cd-timeline-block:nth-child(even) .cd-timeline-content .cd-read-more {
    float: right;
  }
  .cd-timeline-block:nth-child(even) .cd-timeline-content .cd-date {
    left: auto;
    right: 122%;
    text-align: right;
  }
}
</style>

